// extracted by mini-css-extract-plugin
export default {"Container":"Header_Container__Cmgle","cover":"Header_cover__hR43l"};